import { Card, Row } from 'antd'
import React from 'react'
import Heading from '../../../../component/common/Heading'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import { useNavigate, useParams } from 'react-router-dom'
import { FOND_MODES, convertUTCToLocal } from '../../../../util/functions'

const ModeHistory = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    return (
        <>
            <div>
                <>
                    <Heading>Mode History</Heading>

                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.Mode_History.getAll,
                                extraQuery: { petId: id },
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `MF${data?.id.toString().padStart(7, "0")}`,
                                            view: {
                                                id: data?.id,
                                                onClick: (modeId) => {
                                                    navigate(`/app/pets/${id}/${modeId}`)
                                                },
                                            },
                                            modeD: FOND_MODES[data?.mode] || '-',
                                            activeD: data?.active ? "Yes" : 'No',
                                            isReadD: data?.isRead ? "Yes" : 'No',
                                            startTimeD: data?.startTime ? convertUTCToLocal(data?.startTime, 'hh:mm A') : "",
                                            endTimeD: data?.endTime ? convertUTCToLocal(data?.endTime, 'hh:mm A') : "",


                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.MODE_HISTORY,
                            }}
                            isSearch={true}
                            FILTERSORTKEY={
                                { "modeD": 'mode' }
                            }

                        />
                    </Row>
                </>
            </div>
        </>
    )
}

export default ModeHistory